import { createContext, ReactNode, useContext } from "react";
import decodeToken from "../tool/jwt_decode";

interface TokenProviderProps {
  children: ReactNode;
}
interface UserinfoType {
  exp: number;
  iat: number;
  nickname: string;
  user_level: string;
  userid: string;
}
interface TokenContextType {
  userinfoReturn: () => Promise<UserinfoType>;
  logout: (isAdmin?: string) => void;
}

const TokenContext = createContext<TokenContextType | null>(null);

export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error("최상위에서 <TokenProvider>를 반드시 포함해야합니다");
  }
  return context;
};

export function TokenProvider({ children }: TokenProviderProps) {
  const userinfoReturn = async (): Promise<UserinfoType> => {
    const refreshToken = localStorage.getItem("key") || "";
    return decodeToken(refreshToken);
  };

  const logout = (isAmdin?: string) => {
    localStorage.removeItem("key");
    localStorage.removeItem("authority");
    if (isAmdin) {
      window.location.href = "/admin/login";
    } else {
      window.location.href = "/";
    }
  };

  const contextValue: TokenContextType = {
    logout,
    userinfoReturn,
  };

  return (
    <TokenContext.Provider value={contextValue}>
      {children}
    </TokenContext.Provider>
  );
}
